var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactLens(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 511.942 511.942",
    height: 512,
    viewBox: "0 0 511.942 511.942",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m493.469 173.212s-95.578 132.964-237.522 132.964-237.522-132.964-237.522-132.964 94.125-132.964 237.522-132.964c141.944 0 237.522 132.964 237.522 132.964z",
    fill: "#e3f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m493.469 173.212s-95.578-132.964-237.522-132.964v265.929c141.944-.001 237.522-132.965 237.522-132.965z",
    fill: "#beebfa"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255.947,
    cy: 145.762,
    fill: "#00cc76",
    r: 120.515
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.462 145.762c0-66.452-54.062-120.515-120.515-120.515v241.029c66.452.001 120.515-54.062 120.515-120.514z",
    fill: "#009986"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255.947,
    cy: 145.762,
    fill: "#2a3860",
    r: 54.296
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.433 351.18v15c0 66.452 54.062 120.515 120.515 120.515s120.515-54.062 120.515-120.515v-15z",
    fill: "#e3f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m474.339 173.279c-9.712 11.768-29.241 33.621-56.415 55.214-23.074 18.335-47.085 32.912-71.366 43.325-29.953 12.845-60.439 19.358-90.611 19.358s-60.658-6.513-90.611-19.358c-24.281-10.413-48.292-24.99-71.366-43.325-27.177-21.595-46.707-43.45-56.415-55.214h-37.555l6.246 8.688c1.025 1.426 25.592 35.312 68.353 69.45 25.219 20.133 51.602 36.202 78.416 47.759 33.871 14.599 68.502 22 102.933 22s69.062-7.402 102.933-22c26.814-11.557 53.197-27.626 78.416-47.759 42.761-34.138 67.328-68.024 68.353-69.45l6.245-8.688z",
    fill: "#ffd9b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.451 173.153c9.563-11.737 28.908-33.626 56.013-55.255 22.958-18.32 46.934-32.886 71.26-43.292 30.029-12.845 60.721-19.358 91.224-19.358 30.172 0 60.658 6.513 90.611 19.358 24.281 10.413 48.292 24.99 71.366 43.325 27.228 21.636 46.781 43.533 56.47 55.281-.018.022-.037.045-.055.067h37.555l.048-.067-6.293-8.755c-1.025-1.426-25.592-35.312-68.353-69.45-25.219-20.133-51.602-36.202-78.416-47.759-33.871-14.599-68.502-22-102.933-22-34.758 0-69.591 7.4-103.534 21.996-26.889 11.562-53.261 27.639-78.384 47.784-42.609 34.166-66.836 68.09-67.847 69.518l-6.183 8.733h37.555c-.034-.042-.069-.084-.104-.126z",
    fill: "#2a3860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.462 366.18v-15h-120.515v135.515c66.452 0 120.515-54.063 120.515-120.515z",
    fill: "#beebfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m474.339 173.279c-9.712 11.768-29.241 33.621-56.415 55.214-23.074 18.335-47.085 32.912-71.366 43.325-29.953 12.845-60.439 19.358-90.611 19.358v30c34.431 0 69.062-7.402 102.933-22 26.814-11.557 53.197-27.626 78.416-47.759 42.761-34.138 67.328-68.024 68.353-69.45l6.245-8.688z",
    fill: "#fb9"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#232e41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m310.244 145.762c0-29.939-24.357-54.296-54.296-54.296v108.592c29.938.001 54.296-24.357 54.296-54.296z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m505.649 164.457c-1.025-1.426-25.592-35.312-68.353-69.45-25.219-20.133-51.602-36.202-78.416-47.759-33.871-14.599-68.502-22-102.933-22v30c30.172 0 60.658 6.513 90.611 19.358 24.281 10.413 48.292 24.99 71.366 43.325 27.228 21.636 46.781 43.533 56.47 55.281-.018.022-.037.045-.055.067h37.555l.048-.067z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactLens);
export default __webpack_public_path__ + "static/media/contact-lens.2e4bae59713e6afe5a31672b3257d5db.svg";
export { ForwardRef as ReactComponent };